import { getTrackingScreenName } from 'helpers';
import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState } from 'react';
import { useGlobalData } from './GlobalDataContext';

export interface ScreenState {
  trackingScreenName?: string;
  setTrackingScreenName?: (val?: string) => void;
}

export interface ScreenProviderProps {
  children: React.ReactNode;
}

const ScreenStateContext = React.createContext<ScreenState>({});

export const ScreenProvider: React.FunctionComponent<ScreenProviderProps> = ({
  children,
}: ScreenProviderProps) => {
  const [trackingScreenName, setTrackingScreenName] = useState<string>();
  const router = useRouter();
  const { tenant, isMobile } = useGlobalData();

  useEffect(() => {
    setTrackingScreenName(
      getTrackingScreenName(tenant, isMobile, router.pathname),
    );
  }, [router]);

  return (
    <ScreenStateContext.Provider
      value={{
        trackingScreenName,
        setTrackingScreenName,
      }}
    >
      {children}
    </ScreenStateContext.Provider>
  );
};

export function useScreen(): ScreenState {
  const context = useContext(ScreenStateContext);
  if (!context) {
    throw new Error(
      'useScreen must be inside a ScreenStateContext with a state value',
    );
  }
  return context;
}
